import * as THREE from 'three';
import { createCelMesh } from './shaders/CelShader.js';

// Fish types with their properties
export const FISH_TYPES = [
  {
    name: 'Red Snapper',
    id: 'red_snapper', // Unique ID
    rarity: 'uncommon',
    color: 0xFF6347, // Tomato Red (for 3D model)
    size: 1.0,       // For 3D model
    points: 15,
    image_url: '/textures/fish.png',
    sprite_col: 0,     // Column index (0, 1, 2)
    sprite_row: 0,     // Row index (0, 1, 2)
    model: null
  },
  {
    name: 'Azure Tidefish',
    id: 'azure_tidefish',
    rarity: 'common',
    color: 0x6495ED, // Cornflower Blue
    size: 0.8,
    points: 5,
    image_url: '/textures/fish.png',
    sprite_col: 1,
    sprite_row: 0,
    model: null
  },
  {
    name: 'Golden Sunfish',
    id: 'golden_sunfish',
    rarity: 'rare',
    color: 0xFFD700, // Gold
    size: 1.2,
    points: 25,
    image_url: '/textures/fish.png',
    sprite_col: 2,
    sprite_row: 0,
    model: null
  },
  {
    name: 'Jade Minnow',
    id: 'jade_minnow',
    rarity: 'common',
    color: 0x3CB371, // Medium Sea Green
    size: 0.7,
    points: 8,
    image_url: '/textures/fish.png',
    sprite_col: 0,
    sprite_row: 1,
    model: null
  },
  {
    name: 'Violet Fantail',
    id: 'violet_fantail',
    rarity: 'rare',
    color: 0x9370DB, // Medium Purple
    size: 1.1,
    points: 30,
    image_url: '/textures/fish.png',
    sprite_col: 1,
    sprite_row: 1,
    model: null
  },
  {
    name: 'Sunset Guppy',
    id: 'sunset_guppy',
    rarity: 'uncommon',
    color: 0xFFA500, // Orange
    size: 0.9,
    points: 12,
    image_url: '/textures/fish.png',
    sprite_col: 2,
    sprite_row: 1,
    model: null
  },
  {
    name: 'Rosefin Tetra',
    id: 'rosefin_tetra',
    rarity: 'common',
    color: 0xFFC0CB, // Pink
    size: 0.6,
    points: 7,
    image_url: '/textures/fish.png',
    sprite_col: 0,
    sprite_row: 2,
    model: null
  },
  {
    name: 'Cerulean Wrasse',
    id: 'cerulean_wrasse',
    rarity: 'uncommon',
    color: 0x40E0D0, // Turquoise
    size: 1.3,
    points: 18,
    image_url: '/textures/fish.png',
    sprite_col: 1,
    sprite_row: 2,
    model: null
  },
  {
    name: 'Abyssal Angler',
    id: 'abyssal_angler',
    rarity: 'legendary',
    color: 0x00008B, // Dark Blue
    size: 2.0,
    points: 100,
    image_url: '/textures/fish.png',
    sprite_col: 2,
    sprite_row: 2,
    model: null
  },
  // --- New fish from fish2.png ---
  {
    name: 'Clownfish Comet',
    id: 'clownfish_comet',
    rarity: 'uncommon',
    color: 0xFFA500, // Orange (for 3D model)
    size: 0.8,       // For 3D model
    points: 16,
    image_url: '/textures/fish2.png',
    sprite_col: 0, 
    sprite_row: 0, 
    model: null
  },
  {
    name: 'Reef Sharklet',
    id: 'reef_sharklet',
    rarity: 'rare',
    color: 0x708090, // Slate Gray
    size: 1.8,
    points: 45,
    image_url: '/textures/fish2.png',
    sprite_col: 1, 
    sprite_row: 0, 
    model: null
  },
  {
    name: 'Sunspot Puffer',
    id: 'sunspot_puffer',
    rarity: 'uncommon',
    color: 0xFFD700, // Gold
    size: 0.9,
    points: 22,
    image_url: '/textures/fish2.png',
    sprite_col: 2, 
    sprite_row: 0, 
    model: null
  },
  {
    name: 'Emerald Samurai',
    id: 'emerald_samurai',
    rarity: 'rare',
    color: 0x2E8B57, // Sea Green
    size: 1.2,
    points: 40,
    image_url: '/textures/fish2.png',
    sprite_col: 0, 
    sprite_row: 1, 
    model: null
  },
  {
    name: 'Violet Queenfish',
    id: 'violet_queenfish',
    rarity: 'rare',
    color: 0x8A2BE2, // Blue Violet
    size: 1.0,
    points: 38,
    image_url: '/textures/fish2.png',
    sprite_col: 1, 
    sprite_row: 1, 
    model: null
  },
  {
    name: 'Ember Dottyback',
    id: 'ember_dottyback',
    rarity: 'common',
    color: 0xFF8C00, // Dark Orange
    size: 1.1,
    points: 9,
    image_url: '/textures/fish2.png',
    sprite_col: 2, 
    sprite_row: 1, 
    model: null
  },
  {
    name: 'Fuchsia Fighter',
    id: 'fuchsia_fighter',
    rarity: 'uncommon',
    color: 0xFF69B4, // Hot Pink
    size: 0.7,
    points: 19,
    image_url: '/textures/fish2.png',
    sprite_col: 0, 
    sprite_row: 2, 
    model: null
  },
  {
    name: 'Magenta Mopey',
    id: 'magenta_mopey',
    rarity: 'common',
    color: 0xC71585, // Medium Violet Red
    size: 0.6,
    points: 6,
    image_url: '/textures/fish2.png',
    sprite_col: 1, 
    sprite_row: 2, 
    model: null
  },
  {
    name: 'Indigo Goofball',
    id: 'indigo_goofball',
    rarity: 'common',
    color: 0x191970, // Midnight Blue
    size: 1.0,
    points: 4,
    image_url: '/textures/fish2.png',
    sprite_col: 2,
    sprite_row: 2,
    model: null
  },
  // === SALTWATER / OCEAN FISH ===
  {
    name: 'Bluefin Tuna',
    id: 'bluefin_tuna',
    rarity: 'rare',
    color: 0x1E90FF, // Dodger Blue
    size: 1.8,
    points: 50,
    image_url: '/textures/fish2.png',
    sprite_col: 0,
    sprite_row: 0,
    waterType: 'saltwater',
    model: null
  },
  {
    name: 'Tiger Shark',
    id: 'tiger_shark',
    rarity: 'legendary',
    color: 0x4A4A4A, // Dark Gray
    size: 2.5,
    points: 150,
    image_url: '/textures/fish2.png',
    sprite_col: 1,
    sprite_row: 0,
    waterType: 'saltwater',
    model: null
  },
  {
    name: 'Neon Jellyfish',
    id: 'neon_jellyfish',
    rarity: 'uncommon',
    color: 0xFF00FF, // Magenta
    size: 0.9,
    points: 20,
    image_url: '/textures/fish2.png',
    sprite_col: 2,
    sprite_row: 0,
    waterType: 'saltwater',
    model: null
  },
  {
    name: 'Ocean Sunfish',
    id: 'ocean_sunfish',
    rarity: 'rare',
    color: 0xB0C4DE, // Light Steel Blue
    size: 2.0,
    points: 60,
    image_url: '/textures/fish2.png',
    sprite_col: 0,
    sprite_row: 1,
    waterType: 'saltwater',
    model: null
  },
  {
    name: 'Sea Turtle',
    id: 'sea_turtle',
    rarity: 'rare',
    color: 0x2E8B57, // Sea Green
    size: 1.5,
    points: 45,
    image_url: '/textures/fish2.png',
    sprite_col: 1,
    sprite_row: 1,
    waterType: 'saltwater',
    model: null
  },
  {
    name: 'Flying Fish',
    id: 'flying_fish',
    rarity: 'common',
    color: 0x87CEEB, // Sky Blue
    size: 0.7,
    points: 10,
    image_url: '/textures/fish2.png',
    sprite_col: 2,
    sprite_row: 1,
    waterType: 'saltwater',
    model: null
  },
  {
    name: 'Coral Crab',
    id: 'coral_crab',
    rarity: 'common',
    color: 0xFF6B6B, // Coral Red
    size: 0.5,
    points: 8,
    image_url: '/textures/fish2.png',
    sprite_col: 0,
    sprite_row: 2,
    waterType: 'saltwater',
    model: null
  },
  {
    name: 'Electric Eel',
    id: 'electric_eel',
    rarity: 'uncommon',
    color: 0xFFFF00, // Yellow
    size: 1.4,
    points: 25,
    image_url: '/textures/fish2.png',
    sprite_col: 1,
    sprite_row: 2,
    waterType: 'saltwater',
    model: null
  },
  {
    name: 'Giant Squid',
    id: 'giant_squid',
    rarity: 'legendary',
    color: 0x8B0000, // Dark Red
    size: 2.2,
    points: 200,
    image_url: '/textures/fish2.png',
    sprite_col: 2,
    sprite_row: 2,
    waterType: 'saltwater',
    model: null
  },
  {
    name: 'Manta Ray',
    id: 'manta_ray',
    rarity: 'rare',
    color: 0x2F4F4F, // Dark Slate Gray
    size: 2.3,
    points: 70,
    image_url: '/textures/fish2.png',
    sprite_col: 0,
    sprite_row: 0,
    waterType: 'saltwater',
    model: null
  }
];

// Initialize fish models
export function initializeFishModels(loader) {
  FISH_TYPES.forEach(fish => {
    // Create fish body
    const bodyGeometry = new THREE.CapsuleGeometry(fish.size * 0.5, fish.size, 8, 8);
    const fishMesh = createCelMesh(bodyGeometry, fish.color);
    
    // Create fish group to hold all parts
    const fishGroup = new THREE.Group();
    fishGroup.add(fishMesh);
    
    // Add tail
    const tailGeometry = new THREE.ConeGeometry(fish.size * 0.4, fish.size * 0.8, 4);
    const tailMesh = createCelMesh(tailGeometry, fish.color);
    tailMesh.position.set(-fish.size * 0.8, 0, 0);
    tailMesh.rotation.z = Math.PI / 2;
    fishGroup.add(tailMesh);
    
    // Add fins
    const finGeometry = new THREE.ConeGeometry(fish.size * 0.2, fish.size * 0.4, 4);
    
    // Top fin
    const topFinMesh = createCelMesh(finGeometry, fish.color);
    topFinMesh.position.set(0, fish.size * 0.5, 0);
    topFinMesh.rotation.z = -Math.PI / 2;
    fishGroup.add(topFinMesh);
    
    // Side fins
    const leftFinMesh = createCelMesh(finGeometry, fish.color);
    leftFinMesh.position.set(0, 0, fish.size * 0.5);
    leftFinMesh.rotation.x = Math.PI / 2;
    leftFinMesh.rotation.z = -Math.PI / 2;
    leftFinMesh.scale.set(0.7, 0.7, 0.7);
    fishGroup.add(leftFinMesh);
    
    const rightFinMesh = createCelMesh(finGeometry, fish.color);
    rightFinMesh.position.set(0, 0, -fish.size * 0.5);
    rightFinMesh.rotation.x = -Math.PI / 2;
    rightFinMesh.rotation.z = -Math.PI / 2;
    rightFinMesh.scale.set(0.7, 0.7, 0.7);
    fishGroup.add(rightFinMesh);
    
    // Add eyes
    const eyeGeometry = new THREE.SphereGeometry(fish.size * 0.1, 8, 8);
    const eyeMaterial = new THREE.MeshBasicMaterial({ color: 0xFFFFFF });
    
    const leftEye = new THREE.Mesh(eyeGeometry, eyeMaterial);
    leftEye.position.set(fish.size * 0.4, fish.size * 0.2, fish.size * 0.3);
    fishGroup.add(leftEye);
    
    const rightEye = new THREE.Mesh(eyeGeometry, eyeMaterial);
    rightEye.position.set(fish.size * 0.4, fish.size * 0.2, -fish.size * 0.3);
    fishGroup.add(rightEye);
    
    // Add pupils
    const pupilGeometry = new THREE.SphereGeometry(fish.size * 0.05, 8, 8);
    const pupilMaterial = new THREE.MeshBasicMaterial({ color: 0x000000 });
    
    const leftPupil = new THREE.Mesh(pupilGeometry, pupilMaterial);
    leftPupil.position.set(fish.size * 0.45, fish.size * 0.22, fish.size * 0.3);
    fishGroup.add(leftPupil);
    
    const rightPupil = new THREE.Mesh(pupilGeometry, pupilMaterial);
    rightPupil.position.set(fish.size * 0.45, fish.size * 0.22, -fish.size * 0.3);
    fishGroup.add(rightPupil);
    
    // Store the model in the fish type
    fish.model = fishGroup;
  });
  
  return FISH_TYPES;
}

// Get a random fish based on rarity and water type
// waterType: 'freshwater' (default, ponds) or 'saltwater' (ocean)
export function getRandomFish(waterType = 'freshwater') {
  const rand = Math.random();
  let chosenFish;

  // Filter fish by water type (fish without waterType property are freshwater)
  const fishPool = FISH_TYPES.filter(f => {
    if (waterType === 'saltwater') {
      return f.waterType === 'saltwater';
    } else {
      return !f.waterType || f.waterType === 'freshwater';
    }
  });

  // Ensure all rarities are covered and probabilities sum close to 1.
  // Legendary: ~5%
  // Rare: ~20%
  // Uncommon: ~35%
  // Common: ~40%

  const legendaryFish = fishPool.filter(f => f.rarity === 'legendary');
  const rareFish = fishPool.filter(f => f.rarity === 'rare');
  const uncommonFish = fishPool.filter(f => f.rarity === 'uncommon');
  const commonFish = fishPool.filter(f => f.rarity === 'common');

  if (rand < 0.05 && legendaryFish.length > 0) {
    chosenFish = legendaryFish[Math.floor(Math.random() * legendaryFish.length)];
  } else if (rand < 0.25 && rareFish.length > 0) { // 0.05 to 0.249... (20%)
    chosenFish = rareFish[Math.floor(Math.random() * rareFish.length)];
  } else if (rand < 0.60 && uncommonFish.length > 0) { // 0.25 to 0.599... (35%)
    chosenFish = uncommonFish[Math.floor(Math.random() * uncommonFish.length)];
  } else if (commonFish.length > 0) { // 0.60 to 1.0 (40%)
    chosenFish = commonFish[Math.floor(Math.random() * commonFish.length)];
  } else {
    // Fallback if a category is empty for some reason
    chosenFish = fishPool[Math.floor(Math.random() * fishPool.length)];
  }
  return chosenFish;
}

// Create a fish splash animation
export function createFishSplash(scene, position) {
  const particleCount = 20;
  const particles = new THREE.Group();
  
  for (let i = 0; i < particleCount; i++) {
    const size = 0.05 + Math.random() * 0.1;
    const geometry = new THREE.SphereGeometry(size, 8, 8);
    const material = new THREE.MeshBasicMaterial({ color: 0x4488ff });
    const particle = new THREE.Mesh(geometry, material);
    
    // Random position around the splash center
    const angle = Math.random() * Math.PI * 2;
    const radius = Math.random() * 0.5;
    particle.position.set(
      position.x + Math.cos(angle) * radius,
      position.y + Math.random() * 0.5,
      position.z + Math.sin(angle) * radius
    );
    
    // Store velocity for animation
    particle.userData.velocity = new THREE.Vector3(
      (Math.random() - 0.5) * 0.1,
      0.1 + Math.random() * 0.2,
      (Math.random() - 0.5) * 0.1
    );
    
    particles.add(particle);
  }
  
  scene.add(particles);
  
  // Animation function
  const animateSplash = () => {
    let allParticlesGone = true;
    
    particles.children.forEach(particle => {
      // Apply gravity
      particle.userData.velocity.y -= 0.01;
      
      // Move particle
      particle.position.add(particle.userData.velocity);
      
      // Check if particle is still visible
      if (particle.position.y > 0) {
        allParticlesGone = false;
      }
    });
    
    if (allParticlesGone) {
      scene.remove(particles);
      return;
    }
    
    requestAnimationFrame(animateSplash);
  };
  
  animateSplash();
  
  return particles;
} 